// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__1Aqdr","sm":"Link_sm__pDoFX","md":"Link_md__bwm8L","lg":"Link_lg__Z7xn5"};